export const body = {
    padding: "10px"
};

export const columnPadding = {
    marginRight: "10px",
    marginLeft: "10px"
};

export const menuItem_HeightAnimation = {
    backgroundColor: "red",
    position: "absolute",
    height: "20px",
    width: "100%",
    zIndex: "1",
    transition: "all 0.5s ease-out"
};

export const menuItem_WidthAnimation = {
    backgroundColor: "blue",
    // position: "absolute",
    height: "40px",
    // zIndex: "0",
    transition: "all 1s ease-out"
};

export const menu_colorFadeAnimation = {
    height: "40px",
    width: "100px",
    transition: "all 1s ease-out"
};

//GROW MENU

export const menu_GrowMenuTopButton = {
    height: "40px",
    width: "100%",
    backgroundColor: "purple"
};

export const menu_GrowMenuAnimation = {
    width: "100%",
    backgroundColor: "green",
    transition: "all 0.5s ease-out",
    overflow: "hidden"
};

export const menu_GrowMenuItem = {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignContent: "center",
    textAlign: "center",
    backgroundColor: "pink",
    height: "30px"
};

export const boxShape = {
    backgroundColor: "purple",
    height: "100px",
    width: "100px",
    borderRadius: "0% 0% 25% 0%"
};
